"use strict";
// Copyright (c) 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingTypes = void 0;
var MappingTypes;
(function (MappingTypes) {
    MappingTypes["Adapter"] = "adapter";
    MappingTypes["Function"] = "function";
    MappingTypes["Self"] = "self";
})(MappingTypes = exports.MappingTypes || (exports.MappingTypes = {}));
